import { api } from "@services/api";
import { type Task } from "@services/task/types";
import { type Vessel } from "./vessel/types";

export interface CompleteTaskByIdArgs {
  status: string;
  internalNotes?: string;
  internalNotesDocument?: string;
  internalNotesDocumentName?: string;
  externalNotes?: string;
  externalNotesDocument?: string;
  externalNotesDocumentName?: string;
}

export const getTaskById = async (service: string, taskId?: string) => {
  return api.get<Vessel>(service, `tasks/${taskId}`);
};

export const claimTaskByVesselId = async (
  service: string,
  vesselId: string,
  transactionId?: string,
) => {
  return api.put<Task>(
    service,
    `tasks/${vesselId}:claim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const unclaimTaskByVesselId = async (
  service: string,
  vesselId: string,
  transactionId?: string,
) => {
  return api.put<Task>(
    service,
    `tasks/${vesselId}:unclaim`,
    ...(transactionId ? [undefined, { transactionId }] : []),
  );
};

export const completeTaskByVesselId = async ({
  service,
  vesselId,
  params,
  transactionId,
}: {
  service: string;
  vesselId: string;
  params: CompleteTaskByIdArgs;
  transactionId?: string;
}) => {
  return api.put<Task>(
    service,
    `tasks/${vesselId}:complete`,
    { ...params },
    ...(transactionId ? [{ transactionId }] : []),
  );
};
